import {initializeApp, FirebaseApp, FirebaseOptions} from 'firebase/app';
import {
  User,
  getAuth,
  Auth,
  connectAuthEmulator,
  signInWithEmailAndPassword,
  signOut,
} from 'firebase/auth';

const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyDI-_GsVS1QEXFIcgpB6KcZ7Xyburm9H_U',
  authDomain: 'wacwac-product.firebaseapp.com',
  databaseURL: 'https://wacwac-product.firebaseio.com',
  projectId: 'wacwac-product',
  storageBucket: 'wacwac-product.appspot.com',
  messagingSenderId: '945204253332',
  appId: '1:945204253332:web:19dcece9bb7ab7b96a9a81',
};

const firebaseStageConfig: FirebaseOptions = {
  apiKey: 'AIzaSyCl70ODPhnvSON8gZFA0o8L4SbUxEmDoiI',
  authDomain: 'wacwac-staging.firebaseapp.com',
  databaseURL: 'https://wacwac-staging.firebaseio.com',
  projectId: 'wacwac-staging',
  storageBucket: 'wacwac-staging.appspot.com',
  messagingSenderId: '355206167652',
  appId: '1:355206167652:web:e1ec10f3d177a23c083371',
};

let app: FirebaseApp;
export let auth: Auth;
if (process.env) {
  switch (process.env.NODE_ENV) {
    case 'production':
      app = initializeApp(firebaseConfig);
      // firebase.initializeApp(firebaseStageConfig);
      auth = getAuth(app);
      break;
    case 'development':
      app = initializeApp(firebaseStageConfig);
      auth = getAuth(app);
      if (process?.env?.NODE_ENV === 'development') {
        connectAuthEmulator(auth, 'http://localhost:8089');
      }

      break;
    case 'staging':
      app = initializeApp(firebaseStageConfig);
      auth = getAuth(app);
      break;
    case 'test':
      app = initializeApp(firebaseStageConfig);
      auth = getAuth(app);
      break;
  }
}

export default {
  async auth(email: string, password: string): Promise<User | undefined> {
    const cre = await signInWithEmailAndPassword(auth, email, password);
    return await cre?.user;
  },

  async logout(): Promise<void> {
    await signOut(auth);
  },
};
